import React from 'react';
import Input from '../../../components/ui/Input';

const AdminAccountForm = ({ formData, errors, onChange, currentLanguage }) => {
  const content = {
    fr: {
      firstName: 'Prénom',
      firstNamePlaceholder: 'Votre prénom',
      lastName: 'Nom',
      lastNamePlaceholder: 'Votre nom',
      adminEmail: 'Email administrateur',
      adminEmailPlaceholder: 'admin@agence.ma',
      adminPhone: 'Téléphone administrateur',
      adminPhonePlaceholder: '+212 6XX-XXXXXX',
      password: 'Mot de passe',
      passwordPlaceholder: 'Minimum 8 caractères',
      confirmPassword: 'Confirmer le mot de passe',
      confirmPasswordPlaceholder: 'Retapez votre mot de passe',
      passwordHint: 'Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule et un chiffre'
    },
    ar: {
      firstName: 'الاسم الأول',
      firstNamePlaceholder: 'اسمك الأول',
      lastName: 'اسم العائلة',
      lastNamePlaceholder: 'اسم عائلتك',
      adminEmail: 'البريد الإلكتروني للمسؤول',
      adminEmailPlaceholder: 'admin@agence.ma',
      adminPhone: 'هاتف المسؤول',
      adminPhonePlaceholder: '+212 6XX-XXXXXX',
      password: 'كلمة المرور',
      passwordPlaceholder: 'على الأقل 8 أحرف',
      confirmPassword: 'تأكيد كلمة المرور',
      confirmPasswordPlaceholder: 'أعد إدخال كلمة المرور',
      passwordHint: 'يجب أن تحتوي كلمة المرور على 8 أحرف على الأقل، حرف كبير، حرف صغير ورقم'
    }
  };

  const text = content?.[currentLanguage];

  return (
    <div className="space-y-4 md:space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label={text?.firstName}
          type="text"
          name="firstName"
          placeholder={text?.firstNamePlaceholder}
          value={formData?.firstName}
          onChange={onChange}
          error={errors?.firstName}
          required
        />

        <Input
          label={text?.lastName}
          type="text"
          name="lastName"
          placeholder={text?.lastNamePlaceholder}
          value={formData?.lastName}
          onChange={onChange}
          error={errors?.lastName}
          required
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label={text?.adminEmail}
          type="email"
          name="adminEmail"
          placeholder={text?.adminEmailPlaceholder}
          value={formData?.adminEmail}
          onChange={onChange}
          error={errors?.adminEmail}
          required
        />

        <Input
          label={text?.adminPhone}
          type="tel"
          name="adminPhone"
          placeholder={text?.adminPhonePlaceholder}
          value={formData?.adminPhone}
          onChange={onChange}
          error={errors?.adminPhone}
          required
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
        <Input
          label={text?.password}
          type="password"
          name="password"
          placeholder={text?.passwordPlaceholder}
          value={formData?.password}
          onChange={onChange}
          error={errors?.password}
          description={text?.passwordHint}
          required
        />

        <Input
          label={text?.confirmPassword}
          type="password"
          name="confirmPassword"
          placeholder={text?.confirmPasswordPlaceholder}
          value={formData?.confirmPassword}
          onChange={onChange}
          error={errors?.confirmPassword}
          required
        />
      </div>
    </div>
  );
};

export default AdminAccountForm;